// video fullscreen icon
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('deferred-media').forEach(function(media) {
    const btn = media.querySelector('.deferred-media__fullscreen-btn');
    if (!btn) return;
  
    if (window.innerWidth < 750) return;

    media.addEventListener('click', function() {
      const video = media.querySelector('video');
      if (!video) return;
      video.addEventListener('play', function() {
        btn.classList.add('is-visible');
      }, { once: false });
    }, { once: true });

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      const video = media.querySelector('video');
      if (video) video.requestFullscreen();
    });
  });
});

// Google event for predictive search
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('#cmdk-input');
  if (!searchInput) return;

  let searchTimeout;
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(function() {
      const term = searchInput.value.trim();
      if (term.length > 2) {
        if (typeof gtag === 'function') {
          gtag('event', 'search', {
            search_term: term
          });
        }
      }
    }, 1000);
  });
});
